import { AdyenPaymentMethodType } from "@faire/deprecated-retailer-visitor-shared/components/AddPaymentMethods/consts";
import { lazy } from "react";

export const lazyIcons = {
  [AdyenPaymentMethodType.SEPA]: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Sepa" */ `@faire/icons/payment-methods/Sepa`
    ).then((m) => ({ default: m.Sepa }))
  ),
  [AdyenPaymentMethodType.SOFORT]: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Klarna" */ `@faire/icons/payment-methods/Klarna`
    ).then((m) => ({ default: m.Klarna }))
  ),
  [AdyenPaymentMethodType.IDEAL]: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Ideal" */ `@faire/icons/payment-methods/Ideal`
    ).then((m) => ({ default: m.Ideal }))
  ),
  [AdyenPaymentMethodType.BACS]: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-BACS" */ `@faire/icons/payment-methods/BACS`
    ).then((m) => ({ default: m.BACS }))
  ),
  cartebancaire: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-CB" */ `@faire/icons/payment-methods/CB`
    ).then((m) => ({ default: m.CB }))
  ),
  visa: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Visa" */ `@faire/icons/payment-methods/Visa`
    ).then((m) => ({ default: m.Visa }))
  ),
  mc: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-MasterCard" */ `@faire/icons/payment-methods/MasterCard`
    ).then((m) => ({ default: m.MasterCard }))
  ),
  amex: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Amex" */ `@faire/icons/payment-methods/Amex`
    ).then((m) => ({ default: m.Amex }))
  ),
  discover: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Discover" */ `@faire/icons/payment-methods/Discover`
    ).then((m) => ({ default: m.Discover }))
  ),
  diners: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-Diners" */ `@faire/icons/payment-methods/Diners`
    ).then((m) => ({ default: m.Diners }))
  ),
  ach: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-ACH" */ `@faire/icons/payment-methods/ACH`
    ).then((m) => ({ default: m.ACH }))
  ),
  scheme: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-CardMethod" */ `@faire/icons/payment-methods/CardMethod`
    ).then((m) => ({ default: m.CardMethod }))
  ),
  fairepay: lazy(() =>
    import(
      /* webpackChunkName: "payment-method-icons-faire-pay" */ `@faire/icons/payment-methods/FairePay`
    ).then((m) => ({ default: m.FairePay }))
  ),
};
